export interface TicketLayoutsCount {
  live: number;
  archived: number;
  total: number;
}

export enum TicketLayoutStatus {
  LIVE = 'live',
  ARCHIVE = 'archive',
}

export enum TicketLayoutView {
  MATTER_VIEW = 'Matter View',
  LAYOUT_SETTINGS = 'Layout Settings',
  INTEGRATION_SETTINGS = 'Integration Settings',
}

export enum IntegrationSource {
  CHECKBOX = 'checkbox',
  IRONCLAD = 'ironclad',
}

export interface GetTicketLayoutsResponse {
  data: TicketLayout[];
  count: TicketLayoutsCount;
}

export interface TicketLayout {
  id: string;
  accountId: number;
  name: string;
  description: string;
  isDefault: boolean;
  createdAt: string;
  createdBy: number;
  updatedAt: string;
  updatedBy: number;
  restoredAt: string | null;
  restoredBy: number | null;
  deletedAt: string | null;
  deletedBy: number | null;
  integrationSource: IntegrationSource;
}

interface LayoutFieldSelectMetadata {
  placeholderText: string;
  defaultValue: string | null;
}

interface LayoutFieldNumberMetadata {
  min: number;
  max: number;
}

// NOTE: To be sync with the metadata interface in validator/src/ticketing/layouts/types.ts

export const enum EditMode {
  LAYOUT_INFO = 'layout-info',
  TICKET_FIELD_EDITOR = 'ticket-field-editor',
}

export interface LayoutTableProps {
  keyword?: string;
}
